import React from "react";
import { AlertLevel } from "../types/AlertTypes";

export const CharacterSheetContext = React.createContext({
  showSources: true,
  adminMode: false,
  characterEditMode: true,
  showAllAlerts: false,
  alertLevel: AlertLevel._3_UPDATED,
});
